var $1b599edd948128d1$exports = {};
/** pop up modal for mockup projects */ const $1b599edd948128d1$var$openModalBtn = document.querySelectorAll('[data-modal-target]');
const $1b599edd948128d1$var$closeModalBtn = document.querySelectorAll('[data-close-btn]');
const $1b599edd948128d1$var$overlay = document.getElementById('overlay');
$1b599edd948128d1$var$openModalBtn.forEach((button)=>{
    button.addEventListener('click', ()=>{
        const modal = document.querySelector(button.dataset.modalTarget);
        $1b599edd948128d1$var$openModal(modal);
    });
});
$1b599edd948128d1$var$overlay.addEventListener('click', ()=>{
    const modals = document.querySelectorAll('.modal.active');
    modals.forEach((modal)=>{
        $1b599edd948128d1$var$closeModal(modal);
    });
});
$1b599edd948128d1$var$closeModalBtn.forEach((button)=>{
    button.addEventListener('click', ()=>{
        const modal = button.closest('.modal');
        $1b599edd948128d1$var$closeModal(modal);
    });
});
function $1b599edd948128d1$var$openModal(modal) {
    if (modal == null) return;
    modal.classList.add('active');
    $1b599edd948128d1$var$overlay.classList.add('active');
}
function $1b599edd948128d1$var$closeModal(modal) {
    if (modal == null) return;
    modal.classList.remove('active');
    $1b599edd948128d1$var$overlay.classList.remove('active');
}


//# sourceMappingURL=portfolio.affc687a.js.map
